import React, { ChangeEvent, PropsWithChildren, useState } from 'react';
import { useLocalization } from '../../context/Localization/localization';
import css from './ServiceCard.module.scss';
import { GenericClickable } from '../GenericClickable/GenericClickable';
import { GMDialogInfo } from '../Dialog';
import { GMSizedIcon } from '../Icon';
import { GMCheckbox, GMFormCheckbox } from '../Checkbox';
import { GMGenericButton } from '../ButtonBase';

export interface ServiceCardProps {
    onClick: () => void;
    priceDetails?: string;
    name: string;
    description?: string;
    checked: boolean;
    price: React.ReactNode;
    extraOption?: {
        checked: boolean;
        onClick: () => void;
        label: string;
    };
}
/**
 * @param props children should be ServiceCard components
 */
export const ServiceCardList: React.FC<PropsWithChildren> = (props) => (
    <div className={css.serviceWrapper}>
        <div className={css.services}>{props.children}</div>
    </div>
);

export const ServiceCard: React.FC<ServiceCardProps> = (props) => {
    const Localization = useLocalization();
    const [showDetails, setShowDetails] = useState(false);
    const [showPriceDetails, setShowPriceDetails] = useState(false);

    return (
        <div className={css.serviceCard}>
            <GMGenericButton
                title={props.checked ? Localization.ClickToRemoveService : Localization.ClickToAddToCart}
                onClick={props.onClick}
                id={Localization.ClickToToggleService}
                ariaLabel={Localization.ClickToToggleService}
                ariaChecked={props.checked}
            >
                <div className={css.serviceCardContent}>
                    <div className={css.infoColumn}>
                        <div className={css.serviceDetails}>
                            <div className={css.leftPanel}>
                                <div className={css.icon}>
                                    <GMSizedIcon
                                        iconSize={'large'}
                                        iconType={'Services-Default'}
                                        ariaLabel={Localization.DefaultServiceImage}
                                    />
                                </div>
                                <div className={css.price}>{props.price}</div>
                                {props.priceDetails && (
                                    <div className={css.viewDetails}>
                                        <GenericClickable onClick={() => setShowPriceDetails(true)}>{Localization.ViewDetails}</GenericClickable>
                                    </div>
                                )}
                            </div>
                            <div className={css.content}>
                                <h4 className={css.title}>{props.name}</h4>
                                {showDetails && <div className={css.description}>{props.description}</div>}
                                {props.description && props.description.length > 0 && (
                                    <div className={css.detailsButtonWrapper}>
                                        <GenericClickable onClick={() => setShowDetails(!showDetails)}>
                                            <div className={css.detailsButton}>
                                                {!showDetails && (
                                                    <GMSizedIcon
                                                        iconSize={'medium'}
                                                        iconType={'Details'}
                                                        title={Localization.ClickToReviewDetails}
                                                        ariaLabel={Localization.MoreDetailsIcon}
                                                    />
                                                )}
                                                <span className={css.detailsText}>{showDetails ? Localization.HideDetails : Localization.ShowDetails}</span>
                                            </div>
                                        </GenericClickable>
                                    </div>
                                )}
                            </div>
                        </div>
                        {props.extraOption && (
                            <div onClick={(e) => e.stopPropagation()}>
                                <GMFormCheckbox
                                    label={props.extraOption.label}
                                    labelVariant={'themed'}
                                    checked={props.extraOption.checked}
                                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        props.extraOption!.onClick();
                                    }}

                                />
                            </div>
                        )}
                    </div>
                    <div className={css.checkColumn}>
                        <GMCheckbox checked={props.checked} iconSize={'medium'} />
                    </div>
                </div>
            </GMGenericButton>
            <GMDialogInfo
                ariaLabel={Localization.AdditionalDetails}
                ariaDescribedBy={Localization.AdditionalDetails}
                title={Localization.AdditionalDetails}
                open={showPriceDetails}
                onClose={() => setShowPriceDetails(false)}
            >
                <div id={Localization.AdditionalDetails}>
                    {props.priceDetails}
                </div>
            </GMDialogInfo>
        </div>
    );
};
